export default "__VITE_ASSET__C2_xGAei__"